import { parsePhoneNumber as libParsePhoneNumber } from 'libphonenumber-js/max'
import { createPhoneHelper } from '@myfunnow/web-core/phone'
import { COMMON_DEFAULT_COUNTRY_CODE } from '@/constants/payment'

const corePhoneHelper = createPhoneHelper(COMMON_DEFAULT_COUNTRY_CODE)

// 包裝 phoneHelpers 以處理邊界情況
export const phoneHelpers = {
  ...corePhoneHelper,
  // 覆寫 getCountryCodeForRegion 以處理空字串輸入
  getCountryCodeForRegion: (region: string): string => {
    if (!region || region.trim() === '') {
      return ''
    }
    const result = corePhoneHelper.getCountryCodeForRegion(region)
    // 將 number 轉成 string，如果是 falsy 值則返回空字串
    return result ? String(result) : ''
  },
  /**
   * 解析電話號碼，分離國碼和號碼
   */
  parsePhoneNumber: (phone: string): { phone: string; countryCode: string } => {
    if (!phone) {
      return { phone: '', countryCode: COMMON_DEFAULT_COUNTRY_CODE }
    }

    if (!phone.startsWith('+')) {
      return {
        phone: phone,
        countryCode: COMMON_DEFAULT_COUNTRY_CODE,
      }
    }

    // 如果電話號碼以 + 開頭，表示是國際格式，使用 libphonenumber-js 解析
    try {
      const parsed = libParsePhoneNumber(phone)
      if (parsed && parsed.country) {
        return {
          phone: parsed.nationalNumber,
          countryCode: parsed.country,
        }
      }
    } catch (error) {
      return { phone: '', countryCode: COMMON_DEFAULT_COUNTRY_CODE }
    }

    // 如果無法解析，假設是本地格式
    return {
      phone: phone,
      countryCode: COMMON_DEFAULT_COUNTRY_CODE,
    }
  },
}
